export const TICKET_URL = "https://rosehill.ticketsolve.com/ticketbooth/shows/1173681084";
export const EVENT_DATE = "Sunday 30 August 2026";
export const EVENT_ISO = "2026-08-30T12:00:00";
export const EVENT_LOCATION = "Whitehaven Harbour, Cumbria";
export const PRIDE_EMAIL = "rocco.boyd@nead.uk";

// name -> default photo (null = branded gradient placeholder, admin can upload later)
export const LINEUP = [
  { name: "Vengaboys", photo: "/lineup/vengaboys.jpg", headline: true },
  { name: "Sydnie Christmas", photo: "/lineup/sydnie-christmas.jpg", headline: true },
  { name: "Micky Modelle", photo: "/lineup/micky-modelle.jpg" },
  { name: "The Tomorrow", photo: "/lineup/the-tomorrow.jpg" },
  { name: "Conleth Kane", photo: null },
  { name: "Liam Moorhouse", photo: "/lineup/liam-moorhouse.jpg" },
  { name: "Mandi Leonard", photo: null },
  { name: "Crowd Karaoke", photo: null },
  { name: "Channy", photo: "/lineup/channy.jpg" },
  { name: "Bev Lyons", photo: null },
  { name: "Just The Brave", photo: "/lineup/just-the-brave.jpg" },
  { name: "Nikk Mager", photo: "/lineup/nikk-mager.jpg" },
  { name: "Mary Kiani", photo: "/lineup/mary-kiani.jpg" },
  { name: "Blitz Kidz", photo: "/lineup/blitz-kidz.jpg" },
];

export const GRADS = [
  ["#e6007e", "#1ba7e0"], ["#7c3aed", "#e6007e"], ["#1ba7e0", "#10b981"],
  ["#f59e0b", "#e6007e"], ["#ef4444", "#f59e0b"], ["#1ba7e0", "#7c3aed"], ["#e6007e", "#f59e0b"],
];

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
export const initials = (name) => {
  const parts = name.split(" ").filter(Boolean);
  return (parts.length === 1 ? parts[0].slice(0, 2) : parts[0][0] + parts[1][0]).toUpperCase();
};
